export class SubAssignment {
    checked = true;
    nr: string;
    index: number;
}
